import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PageTitle from './layout/PageTitle';
import { Button, Container } from 'react-bootstrap';

export default function CreateUser() {
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const inputs = { name: event.target.name.value, email: event.target.email.value };
    axios.post(`https://filenamebuilder.com/api/users.php/save`, inputs).then(function (response) {
      console.log(response);
      navigate('/users');
    });
  };

  return (
    <>
      <PageTitle title="Create User" />
      <Container>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input type="text" name="name" placeholder="First & Last" />
            <div id="emailHelp" className="form-text">
              We&apos;ll never share your email with anyone else.
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input type="text" name="email" placeholder="email" />
          </div>
          <Button type="submit">Create</Button>
        </form>
      </Container>
    </>
  );
}
